export default function OperationalIntegrity() {
  const features = [{
    letter: "S",
    title: "Simplicity",
    description: "One QR. No app install required for clients. They scan, tap Apple Pay, and walk away."
  }, {
    letter: "A",
    title: "Automation",
    description: "Sessions deduct themselves in real-time. Client gets text balance updates automatically."
  }, {
    letter: "N",
    title: "No commitment",
    description: "Cancel anytime. We don't lock you in with monthly contracts or licensing fees."
  }, {
    letter: "N",
    title: "No hardware",
    description: "Works on your existing phone/tablet. No bulky card terminals or clunky iPad setups."
  }, {
    letter: "N",
    title: "No training",
    description: "Your staff won't even notice. Except the massive surge in cash flow and package sales."
  }];
  return <section style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(42, 45, 43)",
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: "96px",
    paddingBottom: "96px",
    animation: "none 0s ease 0s 1 normal none running"
  }}>
      <div className="page-container">
        <div className="flex flex-col items-center" style={{
        maxWidth: "800px",
        marginInline: "auto"
      }}>
          <p className="text-center font-semibold tracking-widest uppercase mb-3" style={{
          color: "#C8985C",
          fontSize: "11px",
          letterSpacing: "0.15em"
        }}>
            OPERATIONAL INTEGRITY
          </p>

          <h2 className="text-center mb-12" style={{
          color: "rgb(31, 58, 46)",
          fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          fontSize: "36px",
          fontWeight: "400",
          lineHeight: "40px",
          border: "0px solid oklch(0.69 0.04 165 / 0.25)",
          textAlign: "center",
          animation: "none 0s ease 0s 1 normal none running"
        }}>
            Luxury spa operations run on simplicity.
          </h2>

          <div className="flex flex-col w-full" style={{
          gap: "16px"
        }}>
            {features.map((feature, index) => <div key={index} className="flex flex-row items-center w-full" style={{
            backgroundColor: "oklch(96% .01 80)",
            borderRadius: "10px",
            border: "1px solid rgba(31, 58, 46, 0.12)",
            paddingTop: "20px",
            paddingBottom: "20px",
            paddingLeft: "24px",
            paddingRight: "24px",
            gap: "0px"
          }}>
                <div className="flex flex-row items-center flex-shrink-0" style={{
              gap: "16px",
              minWidth: "160px"
            }}>
                  <div className="flex items-center justify-center flex-shrink-0" style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "#EBEBE6",
                color: "#1F3A2E",
                fontSize: "15px",
                fontWeight: "600"
              }}>
                    {feature.letter}
                  </div>
                  <span className="font-bold" style={{
                color: "rgb(31, 58, 46)",
                fontSize: "15px",
                fontWeight: "700",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                whiteSpace: "nowrap"
              }}>
                    {feature.title}
                  </span>
                </div>

                <p className="flex-1 text-left" style={{
              color: "rgba(42, 45, 43, 0.7)",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              border: "0px solid oklch(0.69 0.04 165 / 0.25)",
              animation: "none 0s ease 0s 1 normal none running",
              paddingLeft: "48px",
              margin: "0"
            }}>
                  {feature.description}
                </p>

                <div className="flex-shrink-0 flex items-center" style={{
              paddingLeft: "24px",
              color: "#1F3A2E"
            }}>
                  <span dangerouslySetInnerHTML={{
                __html: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg>`
              }} />
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}